<template>
    <v-dialog :value="value" persistent max-width="650px">
        <v-card>
            <v-card-title>
                {{ $t('assign_location') }}
            </v-card-title>
            <v-card-text>
                <div class="mb-5">
                    <LabelField :label="$t('search')">
                        <v-autocomplete
                            v-model="assignedLocation"
                            :loading="loading"
                            :items="foundLocations.models"
                            item-text="titleWithLocation"
                            item-value="id"
                            return-object
                            :search-input.sync="query"
                            no-filter
                            dense
                            outlined
                            append-icon="ic ic-16 ic-searchmagnifier"
                            hide-no-data
                            hide-details
                            :placeholder="$t('search_location')"
                        >
                            <template #item="data">
                                <AddressComboListItem :item="data.item" />
                            </template>
                        </v-autocomplete>
                    </LabelField>
                    <KpAlert v-if="assignedLocation?.event_organizer" color="warning" class="mt-2">
                        {{ $t('location_already_assigned') }}<br />
                        <strong>{{ assignedLocation.event_organizer }}</strong>
                    </KpAlert>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <PlainBtn @click="$emit('input', false)">{{ $t('schliessen') }}</PlainBtn>
                <ActionBtn
                    :disabled="!assignedLocation"
                    @click="$emit('select-location', { location: assignedLocation })"
                >
                    <KpIcon icon-cls="pencil" color="white" />
                    <span>{{ $t('assign_location') }}</span>
                </ActionBtn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Location, LocationCollection } from '@/models/Location';
import { debounce } from '@/helpers/tools';
import { defineComponent } from 'vue';
import AddressComboListItem from './AddressComboListItem.vue';

export default defineComponent({
    name: 'LinkExistingLocation',
    components: { AddressComboListItem },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const collection = new LocationCollection();
        // Filter locations: only see own locations:
        collection.addExtraParam('filter_locations_for_eo', true);
        return {
            assignedLocation: null,
            loading: false,
            foundLocations: collection,
            query: '',
        } as {
            assignedLocation: Location | null;
            loading: boolean;
            foundLocations: LocationCollection;
            query: string;
        };
    },
    watch: {
        value(newVal, oldVal) {
            // on show, clear selection:
            if (newVal && !oldVal) {
                this.assignedLocation = null;
                this.foundLocations.clear();
            }
        },
        query(newVal, oldVal) {
            newVal && newVal !== oldVal && newVal.length >= 3 && this.searchLocations(newVal);
        },
    },
    methods: {
        searchLocations: debounce(async function (this: any, query) {
            this.loading = true;
            await this.foundLocations.query({ simpleQuery: query });
            this.loading = false;
        }, 250),
    },
});
</script>
